/**
 * Approval prompts that arrive from outside the current view — a browser
 * extension asking to pair, a passkey ceremony, an MCP client proposing a
 * command — stack above every other dialog. Modal's default is z-50, the same
 * as Settings, so a request arriving while Settings is open rendered BEHIND it:
 * the user enables the browser bridge in Settings, presses Pair, and never sees
 * the request (found in the Windows Sandbox run, 03.10.2026). Same height as
 * the SSH host-key prompts (HOST_KEY_MODAL_Z).
 */
export const APPROVAL_MODAL_Z = 80;
